module.exports = __webpack_public_path__ + "img/2_21.1649a2cb.png";